<!--
  V 0.1.0 - 2024-10-01

-->

<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12"> </v-col>

      <v-col class="mb-0">
        <h1 class="text-h5 font-weight-bold mb-3">{{ VehicleReg }}</h1>

        <p class="subheading font-weight-regular mb-0">
          Inception Date: {{ InceptionDateDisplay }}
          <br />
          Months Active: {{ monthsElapsedDisplay }}

          <br />
          Months Left: {{ 36 - monthsElapsedDisplay }}

        </p>
      </v-col>
    </v-row>

    <v-row no-gutters >
      <v-col >
        <DoughnutChart :sliderValue="percentageElapsed" :centerCircleState="moleState" />
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col class="text-center">
        <h2>Recovery product only</h2>
        <br />
        <p>
          Unless activated for recovery,<br />
          this product does not provide a position.
          <br />
          Once activated for recovery, <br />the tracking unit needs to be
          replaced once the <br />
          recovery process is complete.
          <br />
          The unit needs to be replaced when <br />
          it has six months left of its life cycle … <br />be sure to contact
          Raptor to arrange the replacement.
        </p>
      </v-col>
    </v-row>

    <v-row v-if="debugMode">

        <v-col>
          <v-col> ID: {{ VehicleID }} </v-col>
          <v-divider></v-divider>
          <v-btn @click="iterateMoleState()">Change Center Circle Color</v-btn>
          <v-divider></v-divider>

          <v-slider v-model="percentageElapsed"
                    step="0.01"
                    :min="0"
                    :max="100"
                    label="Slider"></v-slider>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Import the DonutChart component
// import DonutChart from '@/lib/v1/comp/DonutChart.vue' // Adjust the path as necessary
import DoughnutChart from '@/lib/v1/comp/DoughnutChart.v2.vue' // Adjust the path as necessary
//                                       DoughnutChart.v2.vue

export default {
  name: 'Mole',
  components: {
    DoughnutChart
  },
  data () {
    return {
      debugMode: this.$debug,
      moleState: 0,

      LastUpdate: '',
      currentStateIndex: 0,
      Driver: 'None',
      UnitModelId: 0,
      VehicleID: -1,
      isLoading: false,
      VehicleReg: 'None',
      UnitID: '',
      message: '',
      msg: '',
      InceptionDateString: '',
      InceptionDate: null,
      InceptionDateMonths: null,
      InceptionDateDisplay: '',
      currentDate: new Date(),
      diffInMs: 0,
      percentageElapsed: 0,
      daysElapsed: 0,
      monthsElapsedDisplay: 0
    }
  },

  created () {
    console.log('Mole:')
    this.VehicleReg = this.$route.params.VehicleReg
    this.UnitID = this.$route.params.UnitID
    this.date = this.$route.params.dayDate
    this.VehicleID = this.$route.params.VehicleID

    if (this.date) {
      const pathDate = new Date(this.date)
      this.selectedDateModel = pathDate
    }

    this.fetchVehicleData()
  },

  methods: {
    iterateMoleState () {
      this.moleState = (this.moleState + 1) % 3

      console.log('moleState:' + this.moleState)
    },

    isMoreThan48Hours (dateString) {
      const givenDate = new Date(dateString)
      const now = new Date()

      // Calculate the difference in milliseconds
      const diffInMilliseconds = now - givenDate

      // Convert milliseconds to hours
      const diffInHours = diffInMilliseconds / (1000 * 60 * 60)

      // Check if the difference is greater than 48 hours
      return diffInHours > 48
    },

    monthsElapsed (dateString) {
      const givenDate = new Date(dateString)
      const today = new Date()

      // Calculate the difference in years and months
      let yearDiff = today.getFullYear() - givenDate.getFullYear()
      let monthDiff = today.getMonth() - givenDate.getMonth()

      // Adjust for negative month differences
      if (monthDiff < 0) {
        yearDiff--
        monthDiff += 12
      }

      return yearDiff * 12 + monthDiff
    },

    formatDate (date) {
      const options = { year: 'numeric', month: 'short', day: '2-digit' }
      const formattedDate = date
        .toLocaleDateString('en-US', options)
        .replace(',', '')

      return formattedDate
    },

    async fetchVehicleData () {
      try {
        let url = this.$baseUrl
        url += '/api/v2/vehicle'
        url += `/${this.VehicleID}`

        const response = await this.$axios.get(url)
        this.msg = `Vehicle data: ${JSON.stringify(response.data)}`

        this.InceptionDateString = response.data.InceptionDate
        // console.error(this.msg);

        this.InceptionDate = new Date(this.InceptionDateString.split('+')[0])

        this.InceptionDateDisplay = this.formatDate(this.InceptionDate)

        this.diffInMs = this.currentDate - this.InceptionDate

        const months36InMs = 36 * 30.44 * 24 * 60 * 60 * 1000

        this.percentageElapsed = (this.diffInMs / months36InMs) * 100

        // const percentage = Math.min(Math.max(percentageElapsed, 0), 100);

        // Convert milliseconds to days
        const msPerDay = 24 * 60 * 60 * 1000

        this.daysElapsed = Math.round(this.diffInMs / msPerDay)

        this.monthsElapsedDisplay = this.monthsElapsed(
          this.InceptionDateString.split('+')[0]
        )

        this.LastUpdate = response.data.LastUpdate

        if (this.isMoreThan48Hours(this.LastUpdate)) {
          this.moleState = 1
          console.log('this.LastUpdate:' + this.LastUpdate)
        } else {
          this.moleState = 0
        }

        console.log()

        //
      } catch (error) {
        this.message = 'Error fetching vehicle data'
        console.error(error)
      }
    },

    async fetchTrackingUnitData () {
      try {
        let url = this.$baseUrl
        url += '/api/v2/tracking-unit'
        url += `/${this.UnitID}`

        const response = await this.$axios.get(url)
        this.msg = `Vehicle data: ${JSON.stringify(response.data)}`

        this.InceptionDateString = response.data.InceptionDate
        console.error(this.msg)

        this.InceptionDate = new Date(this.InceptionDateString.split('+')[0])

        this.InceptionDateDisplay = this.formatDate(this.InceptionDate)

        this.diffInMs = this.currentDate - this.InceptionDate

        const months36InMs = 36 * 30.44 * 24 * 60 * 60 * 1000

        this.percentageElapsed = (this.diffInMs / months36InMs) * 100

        // const percentage = Math.min(Math.max(percentageElapsed, 0), 100);

        // Convert milliseconds to days
        const msPerDay = 24 * 60 * 60 * 1000

        this.daysElapsed = Math.round(this.diffInMs / msPerDay)

        this.monthsElapsedDisplay = this.monthsElapsed(
          this.InceptionDateString.split('+')[0]
        )

        Console.log()

        //
      } catch (error) {
        this.message = 'Error fetching vehicle data'
        console.error(error)
      }
    }
  }
}
</script>
